// extracted by mini-css-extract-plugin
export var form = "_ee-0";